export default [
  {
    path: '/activity/index',
    component: () => import('../../views/activity/index.vue'),
    name: 'activity-index',
    meta: {
      auth: 0,
      title: '看看你有多少核能量',
    },
  },
  {
    auth: 0,
    path: '/activity/login',
    component: () => import('../../views/activity/login.vue'),
    name: 'activity-login',
    meta: {
      title: '看看你有多少核能量',
    },
  },
  {
    auth: 0,
    path: '/activity/deactive',
    component: () => import('../../views/activity/deactive.vue'),
    name: 'activity-deactive',
    meta: {
      title: '看看你有多少核能量',
    },
  },
  {
    auth: 0,
    path: '/activity/active',
    component: () => import('../../views/activity/active.vue'),
    name: 'activity-active',
    meta: {
      title: '看看你有多少核能量',
    },
  },
  // 活动-签到
  {
    path: '/activity/signin',
    name: 'activity-signin',
    component: () => import('@/views/activity/signin/Index.vue'),
    meta: {
      auth: 0,
      title: '',
      keepAlive: false,
    },
  },
  {
    path: '/activity/signin-prizes',
    name: 'activity-signin-prizes',
    component: () => import('@/views/activity/signin/prizesList.vue'),
    meta: {
      auth: 0,
      title: '盲盒奖品',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity/signin-rules',
    name: 'activity-signin-rules',
    component: () => import('@/views/activity/signin/rules.vue'),
    meta: {
      auth: 0,
      title: '签到规则',
    },
  },
  {
    path: '/activity/signin/address',
    name: 'activity-signin-address',
    component: () => import('@/views/activity/signin/Address.vue'),
    meta: {
      auth: 0,
      title: '填写收获地址',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity/signin/addressList',
    name: 'activity-signin-addressList',
    component: () => import('@/views/activity/signin/AddressList.vue'),
    meta: {
      auth: 0,
      title: '选择地址',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity/signin/supplementCard',
    name: 'activity-signin-supplementCard',
    component: () => import('@/views/activity/signin/SupplementCard.vue'),
    meta: {
      auth: 1,
      title: '补签卡',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity/signin/supplementCardRules',
    name: 'activity-signin-supplementCardRules',
    component: () => import('@/views/activity/signin/SupplementCardRules.vue'),
    meta: {
      auth: 0,
      title: '补签卡规则',
      backgroundClass: 'bg-gray',
    },
  },
];
